import React, { useEffect, useState } from 'react';
// import lab from '../assets/img/portfolio/Labiconicslogo.png';
// import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import EastSharpIcon from '@mui/icons-material/EastSharp';

const Footer = ({ setHomeKey }) => {

    const [navbarHeight, setNavbarHeight] = useState(0);
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'instant'
        });
    };

    useEffect(() => {
        const updateNavbarHeight = () => {
            const navbar = document.getElementById('header');
            if (navbar) {
                setNavbarHeight(navbar.offsetHeight);
            }
        };

        updateNavbarHeight('70px'); 
        window.addEventListener('resize', updateNavbarHeight);
        
        return () => window.removeEventListener('resize', updateNavbarHeight);
    }, []);

    const SectionLink = ({ to, children }) => {
            if (to === '#CONTACT-US') {
                return (
                    <ScrollLink 
                        to={to.replace('#', '')} 
                        spy={true} 
                        smooth={true} 
                        duration={0} 
                        offset={-navbarHeight}
                        className="footer-navLink"
                    >
                        {children}
                    </ScrollLink>
                );
            } else {
                return (
                    <RouterLink to={to.replace('#', '/')} className="footer-navLink">
                        {children}
                    </RouterLink>
                );
            }
        };
    
    return (
        <div >
            <footer id="footer" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-duration="500">
                <div className='container p-5' style={{fontStyle:'Arial'}}>
                    <div className='row align-items-center'>
                        <div className='col-md-6'>
                            <h2 className='mb-4'><b>Discover Our Product in Action REQUEST A DEMO!</b></h2>
                            <p className='mb-4'>
                                See how our innovative solution can transform your business. REQUEST A DEMO to experience firsthand how our features can meet your specific needs.
                            </p>
                            <p>
                                Whether you're looking to streamline operations, enhance productivity, or increase ROI, our demo will showcase the benefits tailored for you.
                            </p>
                        </div>
                        <div className='col-md-6 d-flex justify-content-center'>
                            <RouterLink to='/demo' className='btn btn-primary btn-lg px-4 py-3 request-demo' style={{ background: '#47b2e4', borderRadius: '0px', border:'1px solid #47b2e4' }} >
                                <h4 className='mb-0' ><b>REQUEST A DEMO</b></h4>
                            </RouterLink>
                        </div>
                    </div>
                </div>

                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 footer-info footer-contact">
                                <h4 className='text-lg-start text-sm-center' style={{ fontFamily: "Arial", color: 'rgba(4,52,111)' }}>Lab Iconics Technologies LLP</h4>
                                <p className='text-start' >
                                3rd Floor, TRENDZ PLATINA, 2-91/12/TP,
                                Survey No.12(P), Kondapur Village, 
                                Serilingampally Mandal, Ranga Reddy District,
                                Hyderabad–500081. Telangana.
                                India.
                                </p>
                                <br></br>
                                <div style={{ color: 'black', textAlign: 'start' }}>
                                    <strong className='text-start' style={{ color: 'rgba(4,52,111)', fontSize: '16px' }}>Phone:</strong><span style={{ fontSize: '15px' }} > +91 8008003103 / +91 8008009926</span><br />
                                    <strong className='text-start' style={{ color: 'rgba(4,52,111)', fontSize: '16px' }}>Email:</strong> <span style={{ fontSize: '16px' }}>info@labiconics.com</span><br />
                                </div>
                            </div>
                            
                            <div className='foot-grid col'>
                                <div className="col-lg-2 col-md-6 footer-links">
                                    <div>
                                        <h4 style={{ color: 'rgba(4,52,111)', textAlign:'left' }}>Quick Links</h4>
                                        <ul className='ml-5 text-dark' style={{ fontSize: '15px' }}>
                                            <li className='text-dark'><i className="bx bx-chevron-right"></i> <RouterLink to='/' href="#HOME" onClick={()=> {scrollToTop(); setHomeKey(prevKey => prevKey + 1);}} >Home <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></RouterLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='#ABOUT' href="#ABOUT" >About us <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div> </SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='/careers' href="#CAREERS" >Careers<div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='#CONTACT-US' href="#CONTACT-US" >Contact Us<div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></SectionLink></li>
                                            {/* <li><i className="bx bx-chevron-right"></i> <RouterLink to='/downloads' href="#DOWNLOADS" >Downloads<div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></RouterLink></li> */}
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 footer-links">
                                    <div>
                                        <h4 style={{ color: 'rgba(4,52,111)', textAlign:'left' }}>Our Solutions</h4>
                                        <ul className='ml-5 myElement' style={{ fontSize: '15px' }}>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='#lims' href="#LIMS" >Lab Iconics LIMS <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div> </SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='#eln' href="#ELN" >Lab Iconics ELN <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div> </SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='#adbs' href="#ADBS" >Lab Iconics ADBS <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div> </SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='#qms' href="#QMS" >Lab Iconics QMS <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div> </SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='#dms' href="#DMS" >Lab Iconics DMS <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div> </SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='#lms' href="#LMS" >Lab Iconics LMS <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div> </SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='#elog' href="#ELOG" >Lab Iconics E-Logbook <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div> </SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='#ipqc' href="#IPQC" >Lab Iconics IPQC <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div> </SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='#vms' href="#VMS" >Lab Iconics VMS <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div> </SectionLink></li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="col-lg-2 col-md-6 footer-links">
                                    <div>
                                        <h4 style={{ color: 'rgba(4,52,111)', textAlign:'left' }}>Resources</h4>
                                        <ul className='ml-5 myElement' style={{ fontSize: '15px' }}>
                                            {/* <li><i className="bx bx-chevron-right"></i> <SectionLink to='/whitepapers' href="#LIMS" >White Papers <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='/webinars' href="#ELN" >Webinars <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></SectionLink></li> */}
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='/blogs' href="#ADBS" >Blogs <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='/downloads' href="#QMS" >Brochure <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></SectionLink></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 footer-links" style={{padding:'0'}}>
                                    <div>
                                        <h4 style={{ color: 'rgba(4,52,111)', textAlign:'left' }}>Industries</h4>
                                        <ul className='ml-5 myElement' style={{ fontSize: '15px' }}>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='/pharma' href="#pharma" >Pharmaceutical Industry<div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='/biotech' href="#biotech" >Biotechnology Industry<div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='/cro-cdmo' href="#cro-cdmo" >CRO/CDMO<div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></SectionLink></li>
                                            <li><i className="bx bx-chevron-right"></i> <SectionLink to='/foodindustry' href="#foodindustry" >Food Technology Industry<div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></SectionLink></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-6 footer-info">
                                <h4 style={{ color: 'rgba(4,52,111)' }}>Our Social Networks</h4>
                                <div className="social-links mt-3">
                                    <a href="https://twitter.com/labiconics" target="_blank" className="twitter" rel='noreferrer' style={{ background: '#47b2e4' }}><i className="bx bxl-twitter"></i></a>
                                    <a href="https://www.facebook.com/people/Lab-Iconics/100090394092719/?mibextid=LQQJ4d" target="_blank" className="facebook" rel='noreferrer' style={{ background: '#47b2e4' }}><i className="bx bxl-facebook"></i></a>
                                    <a href="https://www.linkedin.com/company/lab-icon/" target="_blank" rel='noreferrer' className="linkedin" style={{ background: '#47b2e4' }}><i className="bx bxl-linkedin"></i></a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className='row'>
                        <div className="copyright col-lg-6">
                            &copy; Copyright 2018 <strong><span>Lab Iconics Technologies LLP</span></strong>. All Rights Reserved
                        </div>
                        <div className='copyright col-lg-6'>
                            Designed by  <a href="https://labiconics.com/" target="_blank" rel='noreferrer' style={{ color: '47b2e4' }}>Lab Iconics Technologies LLP</a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
